import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="25" viewBox="0 0 29 25" {...this.props}><path fillRule="evenodd" fill="#1BB7EA" d="M28.492 5.838c-.126 2.791-2.028 6.614-5.711 11.466-3.807 5.066-7.028 7.601-9.662 7.601-1.633 0-3.014-1.542-4.142-4.63l-2.26-8.487c-.838-3.085-1.737-4.63-2.698-4.63-.209 0-.942.452-2.197 1.351L.505 6.771a358.762 358.762 0 0 0 4.086-3.732C6.434 1.408 7.818.55 8.74.464c2.179-.214 3.52 1.311 4.023 4.576.544 3.524.921 5.715 1.132 6.572.629 2.924 1.32 4.384 2.075 4.384.585 0 1.466-.948 2.641-2.845 1.171-1.896 1.799-3.338 1.884-4.33.168-1.636-.461-2.456-1.884-2.456-.671 0-1.363.158-2.073.47 1.377-4.616 4.005-6.858 7.885-6.73 2.878.086 4.235 1.997 4.069 5.733z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/vimeo.svg